var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#96bf72",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.82,83.45c-14.68,0-26.62-11.94-26.62-26.62s11.94-26.62,26.62-26.62,26.62,11.94,26.62,26.62-11.94,26.62-26.62,26.62Zm0-52c-13.99,0-25.38,11.38-25.38,25.38s11.38,25.38,25.38,25.38,25.38-11.38,25.38-25.38-11.38-25.38-25.38-25.38Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.82,77.45c-11.37,0-20.62-9.25-20.62-20.62s9.25-20.62,20.62-20.62,20.62,9.25,20.62,20.62-9.25,20.62-20.62,20.62Zm0-40c-10.68,0-19.38,8.69-19.38,19.38s8.69,19.38,19.38,19.38,19.38-8.69,19.38-19.38-8.69-19.38-19.38-19.38Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.82,57.45h-4c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h4c.35,0,.62.28.62.62s-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.82,57.45h-4c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h4c.35,0,.62.28.62.62s-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.82,77.45c-.35,0-.62-.28-.62-.62v-4c0-.35.28-.62.62-.62s.62.28.62.62v4c0,.35-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.82,41.45c-.35,0-.62-.28-.62-.62v-4c0-.35.28-.62.62-.62s.62.28.62.62v4c0,.35-.28.62-.62.62Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.82,68.45c-.16,0-.32-.06-.44-.18-.19-.19-.24-.47-.12-.71l7-15c.06-.13.17-.24.3-.3l15-7c.24-.11.52-.06.71.12.19.19.24.47.12.71l-7,15c-.06.13-.17.24-.3.3l-15,7c-.08.04-.17.06-.26.06Zm7.47-15.15l-6.18,13.24,13.24-6.18,6.18-13.24-13.24,6.18Zm7.53,7.53h0,0Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.82,61.45c-.16,0-.32-.06-.44-.18l-8-8c-.24-.24-.24-.64,0-.88.24-.24.64-.24.88,0l8,8c.24.24.24.64,0,.88-.12.12-.28.18-.44.18Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultancy);
export default __webpack_public_path__ + "static/media/consultancy.77be587bb4d330503ab97037d36dba09.svg";
export { ForwardRef as ReactComponent };